import { useSearchLocation } from '#/modules/search/contexts/SearchContext';

export function useSearchReady() {
  const searchLocation = useSearchLocation();

  const mainSearchReady = Boolean(searchLocation);

  return { mainSearchReady };
}
